import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Notify from "./notify";
import i18n from "../../utilities/i18n";

const GlobalNotification = () => {
    const dispatch = useDispatch();
    const throttleErrorFlag = useSelector((state) => state.commonStates.throttleErrorFlag);
    const throttleRetrySeconds = useSelector((state) => state.commonStates.throttleRetrySeconds);
    
    const [showNotify, setShowNotify] = useState("hide");
    const [notifyDescription, setNotifyDescription] = useState("");
    const [notifyType, setNotifyType] = useState("error");
    //eslint-disable-next-line
    // const [notifyPrimaryText, setNotifyPrimaryText] = useState("");

    /**
     * Formats a raw number of seconds into a human-readable string (e.g., "1h 5m 30s").
     * This avoids showing users large, confusing numbers like "3660 seconds".
     */
    const getReadableTime = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
    
        const timeParts = [];
        if (hours > 0) timeParts.push(`${hours}h`);
        if (minutes > 0) timeParts.push(`${minutes}m`);
        if (seconds > 0 || timeParts.length === 0) timeParts.push(`${seconds}s`);
    
        return timeParts.join(" ");
    };

    useEffect(() => {
        if (throttleErrorFlag) {
            setShowNotify("show");
            setNotifyType("error");
            // setNotifyPrimaryText("Error");

            // Format the seconds into "Xh Ym Zs"
            const readableTime = getReadableTime(throttleRetrySeconds);
            
            const message = throttleRetrySeconds 
                ? i18n.t("login.tooManyRequestsWithRetry", { time: readableTime })
                : i18n.t("login.tooManyRequestsGeneric");

            setNotifyDescription(message);
            
            setTimeout(() => {
                setShowNotify("hide");
                dispatch({ type: "commonStates/clearThrottleError" });
            }, 4000);
        }
    }, [throttleErrorFlag, throttleRetrySeconds, dispatch]);

    return (
        <Notify
            showNotify={showNotify}
            setShowNotify={setShowNotify}
            // notifyPrimaryText={notifyPrimaryText}
            notifyDescription={notifyDescription}
            setNotifyType={setNotifyType}
            setNotifyDescription={setNotifyDescription}
            notifyType={notifyType}
        />
    );
};

export default GlobalNotification;
